






































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { AppStore } from '@/store/modules/app';
import request from '@/utils/request';
import Utils from '../../../utils/utils';
import AMSDialog from '../../../components/AMSDialog.vue';
import AMSformTable from '../../../components/AMSformTable.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import { getModuleName } from '@/utils/utils';
interface form {
  IsActive?: boolean | undefined;
  Filter?: string | undefined;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-dialog': AMSDialog,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class StaffCount extends Vue {
  valid = true;
  $refs!: { form: HTMLFormElement; formtable: HTMLFormElement };
  form = {
    IsActive: '',
    Filter: ''
  };
  items = [
    {
      text: '系统设置',
      disabled: false,
      href: '/staffCount'
    },
    {
      text: '员工账号',
      disabled: true
    }
  ];
  statusItems = [
    {
      text: '全部',
      value: ''
    },
    {
      text: '已禁用',
      value: false
    },
    {
      text: '已启用',
      value: true
    }
  ];
  headers: object[] = [
    // {
    //   text: '序号',
    //   align: 'center',
    //   width: 60,
    //   sortable: false,
    //   render: (h: any, param: any) => {
    //     return h('div', { ...Utils.stausRenderDiableColor(param.row.isActive) }, `${param.index + 1}  `);
    //   }
    // },
    { text: '姓名', align: 'left', sortable: false, value: 'name', width: 200, isToolTips: true, status: 'isActive' },
    { text: '手机号', align: 'left', value: 'phone', sortable: false, width: 100, status: 'isActive' },
    { text: '角色', align: 'left', value: 'role', sortable: false, width: 200, isToolTips: true, status: 'isActive' },
    { text: '备注', align: 'left', value: 'remark', sortable: false, width: 200, isToolTips: true, status: 'isActive' },
    {
      text: '状态',
      align: 'left',
      sortable: false,
      render: (h: any, params: any) => {
        return h(
          'span',
          {
            style: {
              color: params.row.isActive ? '#00A854' : '#999999'
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          params.row.isActive ? '已启用' : '已禁用'
        );
      },
      width: 100
    },
    Utils.isPermission('SystemSettings.Staff.CreateOrEdit') || Utils.isPermission('SystemSettings.Staff.ToggleActive') || Utils.isPermission('SystemSettings.Staff.ResetPwd')
      ? {
          text: '操作',
          align: 'center',
          sortable: false,
          isDetail: [
            {
              routerName: 'staffCount',
              text: '修改',
              color: '#1ABC9C',
              isParams: true,
              callBack: (btn: any, row: any, key: string) => {
                this.goToEdit(row.item);
              },
              isShowBtn: (row: any) => {
                return Utils.isPermission('SystemSettings.Staff.CreateOrEdit');
              }
            },
            {
              callBack: (btn: any, row: any, key: string) => {
                this.confirmOperate(row.item, 'active');
              },
              text: '启用',
              color: '#1ABC9C',
              isParams: true,
              isShowBtn: (row: any) => {
                return !row.isActive && !row.isSuperAdmin && Utils.isPermission('SystemSettings.Staff.ToggleActive');
              }
            },
            {
              callBack: (btn: any, row: any, key: string) => {
                this.confirmOperate(row.item, 'active');
              },
              text: '禁用',
              color: '#1ABC9C',
              isParams: true,
              isShowBtn: (row: any) => {
                return row.isActive && !row.isSuperAdmin && Utils.isPermission('SystemSettings.Staff.ToggleActive');
              }
            },
            {
              callBack: (btn: any, row: any, key: string) => {
                this.confirmOperate(row.item, 'password');
              },
              text: '重置密码',
              color: '#1ABC9C',
              isParams: true,
              isShowBtn: (row: any) => {
                return !row.isSuperAdmin && Utils.isPermission('SystemSettings.Staff.ResetPwd');
              }
            }
          ],
          width: 200
        }
      : {}
  ];
  api: string = '/api/Staff/List'; //tableapi
  routerhref: string = 'staffCount_create';
  activeDialog: boolean = false;
  requestLoading: boolean = false;
  staffName: string = '';
  activeStatus: boolean = false;
  activeId: string = '';
  //table:
  loading: boolean = false;
  isActive: boolean | undefined = undefined;
  dialogType: string = '';

  onIsActiveClear() {
    setTimeout(() => {
      this.form.IsActive = '';
    }, 1);
  }

  created() {
    // this.getTableData();
     if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  initForm() {
    this.form = { IsActive: '', Filter: '' };
  }
  changePhone(value: string) {
    let data = {
      Filter: value
    };
    // this.getTableData(data);
  }
  activeSure() {
    this.requestLoading = true;
    const self = this;
    if (self.dialogType === 'active') {
      request
        .put(`/api/Staff/${self.activeId}/active`, null)
        .then((data: any) => {
          this.activeDialog = false;
          AppStore.ShowSuccess(self.activeStatus ? `禁用成功！` : `启用成功！`);
          (this.$refs.formtable as HTMLFormElement).query();
        })
        .finally(() => {
          this.requestLoading = false;
        })
        .catch((err: any) => {
          this.requestLoading = false;
          AppStore.ShowError(`操作失败！`);
        });
    } else {
      request
        .put(`/api/Staff/${self.activeId}/resetPwd`, null)
        .then((data: any) => {
          this.activeDialog = false;
          AppStore.ShowSuccess('操作成功！密码已经重置，默认为手机号码后6位');
          (this.$refs.formtable as HTMLFormElement).query();
          this.requestLoading = false;
        })
        .finally(() => {
          this.requestLoading = false;
        })
        .catch((err: any) => {
          this.requestLoading = false;
          AppStore.ShowError(`操作失败！`);
        });
    }
  }
  activeStaff() {
    this.activeDialog = false;
  }
  confirmOperate(item: any, type: string) {
    const self = this;
    self.dialogType = type;
    self.activeDialog = true;
    self.staffName = item.name;
    self.activeId = item.id;
    self.activeStatus = item.isActive;
  }
  goToEdit(record: any) {
    this.$router.push({
      name: this.routerhref,
      query: {
        type: 'edit',
        id: record.id,
        isAdmin: record.isSuperAdmin
      }
    });
  }
  add() {
    this.$router.push({
      name: 'staffCount_create'
    });
  }
}
